export default __webpack_public_path__ + "f8243a6d86504db2d2b494ca27e4f4aa.woff";